const version='ea48a61'; export default version;
